import React from 'react'
import classnames from 'classnames/bind'
import { Spinner } from '@babylon/medkit'

import styles from './Loading.module.scss'

const cx = classnames.bind(styles)

interface Props {
  inline?: boolean
}

const Loading: React.FC<Props> = ({ inline = false }: Props) => (
  <div
    data-testid="loading-component"
    className={cx(styles.loading, {
      'loading--inline': inline,
    })}
  >
    <Spinner variant="primary" />
  </div>
)

export default Loading
